import React from 'react';
import {Grid, Typography} from '@mui/material';
import {Sx} from 'app/types/common';
import {packSx} from 'app/util/packSx/packSx';

type Props = Sx & {showUnit: boolean};

export function ListHeader({sx, showUnit}: Props) {
  return (
    <Grid
      sx={packSx({borderBottom: 1, borderColor: (t) => t.palette.divider}, sx)}
      pb={0.5}
      fontSize={12}
      color="text.secondary"
      columns={24}
      container={true}
      columnGap={1}
      alignItems="center"
    >
      <Grid width={40} item={true} />

      <Grid xs={true} item={true}>
        <Typography variant="caption">Name</Typography>
      </Grid>

      <Grid width={100} item={true}>
        <Typography variant="caption">Size</Typography>
      </Grid>

      <Grid width={100} item={true}>
        <Typography variant="caption">Duration</Typography>
      </Grid>

      <Grid width={100} item={true}>
        <Typography variant="caption">Date</Typography>
      </Grid>

      {showUnit && (
        <Grid width={100} item={true}>
          <Typography variant="caption">Device</Typography>
        </Grid>
      )}
      <Grid width={140} item={true} />
    </Grid>
  );
}
